export const nextDayPortMigrationCutoffHour = 16;
export const nextDayPortMigrationCutoffMin = 0;
export const bundleNetworks = [192, 218, 225];
export const realtimeBundleControlNetworks = [192, 218, 225, 234];
export const manxIotNetworks = [233, 232];
export const iotNetworks = [224, 225, 232, 233];
export const esimHistoryNetworks = [218, 225, 234];
export const sdtrNetworks = [234];
export const vodafoneGdspNetworks = [240, 245];
export const eeNetworks = [230, 239];
export const mobileBreakpoint = 575.98;
declare const env: string;
declare const appVersion: string;

const resolvedAppVersion = typeof appVersion === 'undefined' ? '' : appVersion;

// running on localhost points at dev: the host cannot be derived the way the deployed environments do
const local = {
  PORTAL_BASE_URL: 'http://localhost:5001',
  AUTH_BASE_URL: 'https://auth.dev.cellhire.com',
  API_BASE_URL: 'https://api.dev.cellhire.com/',
  APPINSIGHTS_CONNECTION_STRING: '',
  APP_VERSION: resolvedAppVersion
};

const dev = {
  PORTAL_BASE_URL: 'https://simcontrol.dev.' + getCanonicalHost(window.location.host),
  AUTH_BASE_URL: 'https://auth.dev.' + getCanonicalHost(window.location.host),
  API_BASE_URL: 'https://api.dev.' + getCanonicalHost(window.location.host) + '/',
  APPINSIGHTS_CONNECTION_STRING: '',
  APP_VERSION: resolvedAppVersion
};

const live = {
  PORTAL_BASE_URL: 'https://simcontrol.' + getCanonicalHost(window.location.host),
  AUTH_BASE_URL: 'https://auth.' + getCanonicalHost(window.location.host),
  API_BASE_URL: 'https://api.' + getCanonicalHost(window.location.host) + '/',
  APPINSIGHTS_CONNECTION_STRING:
    'InstrumentationKey=997d0cab-f854-441a-9562-40941db9ef2c;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=fe208fc5-dd44-4327-9b35-6fb7a80aa172',
  APP_VERSION: resolvedAppVersion
};

function getCanonicalHost(hostname: string) {
  const MAX_TLD_LENGTH = 3;

  function isNotTLD(part: string) {
    return part.length > MAX_TLD_LENGTH;
  }

  const parts = hostname.split('.');
  let firstNonTldIndex = 0;

  for (let i = parts.length - 1; i >= 0; i--) {
    if (isNotTLD(parts[i])) {
      firstNonTldIndex = i;
      break;
    }
  }

  return parts.slice(firstNonTldIndex).join('.');
}

type EnvironmentName = 'local' | 'dev' | 'live';
type EnvironmentSettings = typeof local;
type AppConfiguration = EnvironmentSettings & { isLocal: () => boolean };

const config = (() => {
  const currentEnv = typeof env === 'undefined' ? 'dev' : env;
  console.log('env: ' + currentEnv);
  const environments: Record<EnvironmentName, EnvironmentSettings> = {
    local: local,
    dev: dev,
    live: live
  };
  const loweredEnv = currentEnv.toLowerCase();
  const environmentName: EnvironmentName = loweredEnv in environments ? (loweredEnv as EnvironmentName) : 'dev';
  const settings = environments[environmentName];

  return {
    ...settings,
    isLocal: () => environmentName === 'local'
  };
})();

export default config;
